'use client';
import t from 'tiny-warning';

function deprecatedPropValues(r, n, o) {
    let t$1 = false;
    return function(u, a, p, l, s, ...d) {
        let i = p || '<<anonymous>>', c = s || a;
        return null != u[a] && !u.__dangerouslySuppressWarning && n.includes(u[a]) && (t(t$1, `The \`${c}\`=\`${u[a]}\` value of \`${i}\` is deprecated. ${o}.`), t$1 || console.warn(`${i}: props received =======>`, u), t$1 = true), r(u, a, p, l, s, ...d);
    };
}

export { deprecatedPropValues };
